import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const HIGHLIGHTS = [
    "Gespecialiseerd in jeugd & LVB",
    "Ervaren in de-escalatie",
    "Snel inzetbaar bij crisis",
    "Werkt voor gemeenten, Wmo & instellingen",
    "Vast aanspreekpunt, ook in nazorg",
];

export default function About() {
    return (
        <section id="over-mij" data-testid="about-section" className="bg-sand-100/60 py-24 lg:py-32">
            <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
                <Reveal className="relative">
                    <div className="absolute -inset-4 -z-0 rounded-[2.5rem] bg-terracotta/10" />
                    <img
                        src={IMAGES.about}
                        alt="Begeleider Tuncay in gesprek"
                        data-testid="about-caregiver-image"
                        className="relative z-10 aspect-[4/5] w-full rounded-[2.5rem] border border-line object-cover shadow-xl"
                    />
                    <div className="absolute -bottom-5 -right-3 z-20 rounded-2xl border border-line bg-white px-5 py-4 shadow-xl sm:-right-6">
                        <p className="font-serif text-3xl font-semibold text-terracotta">24/7</p>
                        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-moss-900/60">
                            bereikbaar bij crisis
                        </p>
                    </div>
                </Reveal>

                <div>
                    <Reveal>
                        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terracotta">
                            Over Freelance T
                        </p>
                        <h2 className="mt-4 font-serif text-3xl font-semibold leading-snug tracking-tight sm:text-4xl">
                            Ervaren in crisissituaties. Menselijk in aanpak.
                        </h2>
                        <blockquote
                            data-testid="about-personal-quote"
                            className="mt-6 border-l-4 border-terracotta pl-5"
                        >
                            <p className="font-serif text-xl italic leading-snug text-moss-900/85">
                                "Eén telefoontje is genoeg. Ik sta klaar als het er echt toe
                                doet — voor de jongere, het gezin en de mens met LVB."
                            </p>
                            <cite className="mt-2 block text-xs font-semibold uppercase tracking-[0.18em] text-terracotta not-italic">
                                — Tuncay, zelfstandig begeleider
                            </cite>
                        </blockquote>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-base leading-relaxed text-moss-900/70">
                            Mijn naam is Tuncay, een gedreven zelfstandig begeleider (ZZP),
                            gespecialiseerd in crisisbegeleiding voor jeugd en mensen met een
                            licht verstandelijke beperking (LVB). In situaties waar alles
                            vastloopt, breng ik rust, overzicht en veiligheid terug.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-moss-900/70">
                            Als zelfstandig begeleider ben ik snel inzetbaar en blijf ik het
                            vaste aanspreekpunt — ook na de acute fase. Geen wisselende
                            gezichten, maar vertrouwen, continuïteit en oprechte betrokkenheid.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-moss-900/70">
                            Ik werk zowel rechtstreeks voor cliënten en gezinnen als in opdracht
                            van gemeenten, wijkteams, zorginstellingen en via de Wmo (Wet
                            maatschappelijke ondersteuning).
                        </p>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                            {HIGHLIGHTS.map((item) => (
                                <li key={item} className="flex items-center gap-3 text-sm font-medium">
                                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terracotta/15 text-terracotta">
                                        <Check size={13} strokeWidth={3} />
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
